// pageTemplates.js
// 24 layouts, hand-matched from reference sketch image.
// x/y/w/h sab percentage (0-100) mein hain.

const cover = {
  id: "cover",
  photoFrames: [{ x: 5, y: 5, w: 90, h: 90 }],
};

// 1 — ek bada photo box (jaisa reference image mein), neeche caption ke liye space
const layout1 = {
  id: "layout-1",
  photoFrames: [
    { x: 9, y: 8, w: 82, h: 61 },
  ],
};

// 2 — Page 2: "PREGNANCY NEWS" — bada photo box + headline text neeche
const layout2 = {
  id: "layout-2",
  photoFrames: [
    { x: 8, y: 8, w: 84, h: 58 },
  ],
  texts: [
    { content: "PREGNANCY NEWS", x: 8, y: 76, w: 84, font: "'Permanent Marker', cursive", size: "34px", color: "#1A1A1A", align: "left" },
  ],
};

// 3 — Page 3: 2 stacked photo boxes + right sidebar text "1st Trimester"
const layout3 = {
  id: "layout-3",
  photoFrames: [
    { x: 6, y: 6,  w: 62, h: 43 },
    { x: 6, y: 51, w: 62, h: 43 },
  ],
  texts: [
    { content: "1st Trimester", x: 72, y: 6, w: 22, font: "'Caveat', cursive", size: "22px", color: "#1A1A1A", align: "center" },
  ],
};

// 4 — 1 wide rect top-right + 1 chhota rect uske neeche
const layout4 = {
  id: "layout-4",
  photoFrames: [
    { x: 52, y: 10, w: 40, h: 20 },
    { x: 60, y: 34, w: 26, h: 16 },
  ],
};

// 5 — 3 vertical thin strips side by side
const layout5 = {
  id: "layout-5",
  photoFrames: [
    { x: 6,  y: 10, w: 12, h: 60 },
    { x: 22, y: 10, w: 12, h: 60 },
    { x: 38, y: 10, w: 12, h: 60 },
  ],
};

// 6 — scattered small squares (decorative)
const layout6 = {
  id: "layout-6",
  photoFrames: [
    { x: 60, y: 10, w: 10, h: 10 },
    { x: 78, y: 26, w: 9,  h: 9 },
    { x: 62, y: 42, w: 9,  h: 9 },
    { x: 80, y: 46, w: 9,  h: 9 },
  ],
};

// 7 — 2 boxes top (left+right square) + 1 rect bottom-right
const layout7 = {
  id: "layout-7",
  photoFrames: [
    { x: 8,  y: 10, w: 30, h: 26 },
    { x: 42, y: 10, w: 26, h: 22 },
    { x: 46, y: 36, w: 30, h: 22 },
  ],
};

// 8 — 2 boxes top (left square, right square) + 1 rect bottom-left
const layout8 = {
  id: "layout-8",
  photoFrames: [
    { x: 8,  y: 10, w: 26, h: 22 },
    { x: 42, y: 10, w: 30, h: 26 },
    { x: 8,  y: 36, w: 30, h: 22 },
  ],
};

// 9 — 4 small squares 2x2 grid (icon-style)
const layout9 = {
  id: "layout-9",
  photoFrames: [
    { x: 8,  y: 10, w: 16, h: 16 },
    { x: 28, y: 10, w: 16, h: 16 },
    { x: 8,  y: 30, w: 16, h: 16 },
    { x: 28, y: 30, w: 16, h: 16 },
  ],
};

// 10 — ek bada right-center rectangle
const layout10 = {
  id: "layout-10",
  photoFrames: [
    { x: 50, y: 14, w: 40, h: 38 },
  ],
};

// 11 — 3 rects top row (small-medium-small)
const layout11 = {
  id: "layout-11",
  photoFrames: [
    { x: 6,  y: 10, w: 22, h: 18 },
    { x: 30, y: 10, w: 26, h: 18 },
    { x: 58, y: 10, w: 22, h: 18 },
  ],
};

// 12 — 1 medium rect top-right corner
const layout12 = {
  id: "layout-12",
  photoFrames: [
    { x: 58, y: 10, w: 30, h: 22 },
  ],
};

// 13 — 1 chhota rect top-left + 1 wider rect uske neeche
const layout13 = {
  id: "layout-13",
  photoFrames: [
    { x: 8,  y: 10, w: 26, h: 14 },
    { x: 8,  y: 28, w: 40, h: 20 },
  ],
};

// 14 — 1 tiny rect top + 1 chhota rect bottom-right (sparse)
const layout14 = {
  id: "layout-14",
  photoFrames: [
    { x: 8,  y: 10, w: 14, h: 10 },
    { x: 26, y: 36, w: 18, h: 12 },
  ],
};

// 15 — 4 small scattered squares top-left area
const layout15 = {
  id: "layout-15",
  photoFrames: [
    { x: 6,  y: 8,  w: 12, h: 12 },
    { x: 22, y: 8,  w: 12, h: 12 },
    { x: 6,  y: 24, w: 12, h: 12 },
    { x: 22, y: 24, w: 12, h: 12 },
  ],
};

// 16 — 1 bada rect + 1 tall narrow rect uske saath
const layout16 = {
  id: "layout-16",
  photoFrames: [
    { x: 42, y: 10, w: 32, h: 46 },
    { x: 78, y: 10, w: 10, h: 46 },
  ],
};

// 17 — 1 bada single square (large full photo)
const layout17 = {
  id: "layout-17",
  photoFrames: [
    { x: 8,  y: 10, w: 40, h: 46 },
  ],
};

// 18 — 2 rects stacked (right side, medium squares)
const layout18 = {
  id: "layout-18",
  photoFrames: [
    { x: 56, y: 10, w: 28, h: 20 },
    { x: 56, y: 32, w: 28, h: 24 },
  ],
};

// 19 — 1 rect top-left + 1 rect bottom-left
const layout19 = {
  id: "layout-19",
  photoFrames: [
    { x: 8,  y: 10, w: 26, h: 16 },
    { x: 8,  y: 40, w: 22, h: 14 },
  ],
};

// 20 — 1 tall rect + 1 thoda narrow tall rect uske saath
const layout20 = {
  id: "layout-20",
  photoFrames: [
    { x: 42, y: 10, w: 12, h: 30 },
    { x: 58, y: 18, w: 14, h: 40 },
  ],
};

// 21 — ek bada centered square (large single photo)
const layout21 = {
  id: "layout-21",
  photoFrames: [
    { x: 10, y: 8,  w: 48, h: 48 },
  ],
};

// 22 — 2 rects stacked right side (small squares)
const layout22 = {
  id: "layout-22",
  photoFrames: [
    { x: 66, y: 10, w: 22, h: 20 },
    { x: 66, y: 32, w: 22, h: 24 },
  ],
};

// 23 — 1 rect top-left + 1 chhota rect below-right
const layout23 = {
  id: "layout-23",
  photoFrames: [
    { x: 8,  y: 10, w: 32, h: 16 },
    { x: 20, y: 30, w: 24, h: 16 },
  ],
};

// 24 — ek bada right-side square (large single photo)
const layout24 = {
  id: "layout-24",
  photoFrames: [
    { x: 56, y: 8,  w: 36, h: 46 },
  ],
};

export const PAGE_DEFS = [
  cover,
  layout1, layout2, layout3, layout4, layout5, layout6,
  layout7, layout8, layout9, layout10, layout11, layout12,
  layout13, layout14, layout15, layout16, layout17, layout18,
  layout19, layout20, layout21, layout22, layout23, layout24,
];